import ApiService from '../../../../../../services/ApiService'
import HorizontalBarChart from '../../charts/horizontalBarChart'

export default {
  props: {
    filterProp: Object,
  },

  components: {
    HorizontalBarChart,
  },

  async created() {
    this.listTopFiveEquipmentFailures()
  },
  data: () => ({
    loading: false,
    showChart: true,
    page: 1,
    totalPages: 1,
    pageSize: 7,
    expanded: [],
    equipmentName: [],
    legends: [],
    failuresQuantity: [],
    quantityAbuseInUse: [],
    quantityAccidentalDamage: [],
    quantityInfrastructureFailure: [],
    quantityIntrinsicFailure: [],
    quantityOperationalError: [],
    quantityNotApplicable: [],
    topFiveEquipment: [],
    topFiveEquipmentChartData: {},
    options: {},
    filter: {},
    header: [
      {
        text: '',
        align: 'left',
        value: '',
      },
      {
        text: 'Equipamento Padrão',
        align: 'center',
        value: 'standardEquipmentName',
      },
      {
        text: 'Total',
        align: 'center',
        value: 'totalFailures',
      },
      {
        text: 'Erro Operacional',
        align: 'center',
        value: 'quantityOperationalError',
      },
      {
        text: 'Abuso na Utilização',
        align: 'center',
        value: 'quantityAbuseInUse',
      },
      {
        text: 'Dano Acidental',
        align: 'center',
        value: 'quantityAccidentalDamage',
      },
      {
        text: 'Falhas Intrínseca',
        align: 'center',
        value: 'quantityIntrinsicFailure',
      },
      {
        text: 'Falha Infraestrutura',
        align: 'center',
        value: 'quantityInfrastructureFailure',
      },
      {
        text: 'Não Aplicável',
        align: 'center',
        value: 'quantityNotApplicable',
      },
    ],
    headerMobile: [
      {
        text: 'Equipamento Padrão',
        align: 'center',
        value: 'standardEquipmentName',
      },
      {
        text: 'Total',
        align: 'center',
        value: 'totalFailures',
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
    total: 0,
  }),

  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `topFive_Equipment_Failure_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/topFiveEquipmentFailure', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    fillTopFiveEquipment() {
      this.topFiveEquipmentChartData = {
        labels: this.equipmentName,
        datasets: [
          {
            label: this.$t('Erro operacional'),
            data: this.quantityOperationalError,
            backgroundColor: '#426483',
          },
          {
            label: this.$t('Abuso na utilização'),
            data: this.quantityAbuseInUse,
            backgroundColor: '#BBCF20',
          },
          {
            label: this.$t('Dano acidental'),
            data: this.quantityAccidentalDamage,
            backgroundColor: '#0F3565',
          },
          {
            label: this.$t('Falha intrínseca'),
            data: this.quantityIntrinsicFailure,
            backgroundColor: '#212950',
          },
          {
            label: this.$t('Não aplicável'),
            data: this.quantityNotApplicable,
            backgroundColor: '#C4E8F2',
          },
          {
            label: this.$t('Falha infraestrutura'),
            data: this.quantityInfrastructureFailure,
            backgroundColor: '#ED8990',
          },
        ],
      }
    },

    fillOptions() {
      this.options = {
        maintainAspectRatio: false,
        responsive: true,
        barPercentage: 0.5,
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
            },
          ],
        },
        legend: {
          display: true,
          responsive: false,
          maintainAspectRatio: false,
          position: 'right',
          labels: {
            usePointStyle: true,
          },
        },
      }
    },

    async listTopFiveEquipmentFailures() {
      await this.apiService
        .post('reports/topFiveFailures', this.filterProp)
        .then((response) => {
          this.total = response.content.pager.totalItems
          this.equipmentName = []
          this.quantityAbuseInUse = []
          this.quantityAccidentalDamage = []
          this.quantityInfrastructureFailure = []
          this.quantityIntrinsicFailure = []
          this.quantityNotApplicable = []
          this.quantityOperationalError = []
          this.topFiveEquipment = response.content.objects

          this.totalPages = response.content.pager.totalPages
          this.showChart = response.content.objects.length > 0

          response.content.objects.map((obj) => {
            this.equipmentName.push(obj.standardEquipmentName)
            this.quantityAbuseInUse.push(obj.quantityAbuseInUse)
            this.quantityAccidentalDamage.push(obj.quantityAccidentalDamage)
            this.quantityInfrastructureFailure.push(
              obj.quantityInfrastructureFailure
            )
            this.quantityIntrinsicFailure.push(obj.quantityIntrinsicFailure)
            this.quantityNotApplicable.push(obj.quantityNotApplicable)
            this.quantityOperationalError.push(obj.quantityOperationalError)
          })
        })
        .catch((err) => {})

      this.fillTopFiveEquipment()
      this.fillOptions()
    },
  },

  watch: {
    page() {
      this.filterProp.page = this.page
      this.listTopFiveEquipmentFailures()
    },
  },
}
